import axios from "axios";

export default function ChangePassword(props){
    
    function submitHandler(e){
       
        e.preventDefault();
        const obj = new FormData(e.target); 
        axios.put(`${process.env.REACT_APP_BASE_URL}api/user/secured/updateUserPassword`,obj)
        .then(result=>{alert("Create Successfully!");window.location.href="/profile"})
        .catch(err=>alert(err.response.data));
    }

    return(<div className="small-form-container container">
            <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event(false)}>X</button>
        <div className="text-center">
            <h4>Password Change</h4>
        </div><hr />
        <br />
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                         <div>
                            <input className="form-control" type="text" name="password" placeholder="Password" required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="cpassword" placeholder="Confirm Password" required />
                        </div>
                        <div>
                            <button className="btn btn-color form-control">Submit</button>
                        </div> 
                </div> 
            </form>
        </div>
    </div>);
}